import { ClientFrontlineConfig, EquipmentGroup } from '../../../types/types'
export const FrontlineConfig = {
  subscribe:
    (callback: (config: ClientFrontlineConfig) => void) =>
    // Example: fetch or generate a config and call the callback
    // Replace this with actual implementation as needed
    () =>
      callback
}

export const DxGroup = {
  subscribe:
    (callback: (config: Record<string, EquipmentGroup>) => void) =>
    // Example: fetch or generate a config and call the callback
    // Replace this with actual implementation as needed
    () =>
      callback,
  get: () => ({}) as Record<string, EquipmentGroup>,
  set: (_value: Record<string, EquipmentGroup>) => {
    console.log('Setting DxGroup config:', _value)
  }
}
